import React, { useState } from "react";
import Tesseract from "tesseract.js";
import Banner from "../Banner/Banner";
import "./ai.css";

const diseaseDatabase = [
    { name: "tooth decay", medicines: ["Fluoride treatments", "Dental fillings"], remedies: ["Brush twice daily", "Use mouthwash", "Avoid sugary foods"], checkups: ["Dentist", "X-ray scan"] },
    { name: "gum disease", medicines: ["Antibacterial mouthwash", "Antibiotics"], remedies: ["Floss daily", "Avoid tobacco", "Use saltwater rinse"], checkups: ["Dentist", "Periodontal evaluation"] },
    { name: "bad breath", medicines: ["Chlorhexidine mouthwash"], remedies: ["Brush tongue", "Stay hydrated", "Chew sugar-free gum"], checkups: ["Dentist", "Oral hygiene consultation"] },
    { name: "tooth sensitivity", medicines: ["Desensitizing toothpaste", "Fluoride gel"], remedies: ["Avoid acidic foods", "Use soft-bristle toothbrush"], checkups: ["Dentist"] },
    { name: "oral thrush", medicines: ["Antifungal lozenges", "Nystatin"], remedies: ["Rinse with saltwater", "Maintain oral hygiene"], checkups: ["Dentist", "Oral swab test"] },
    { name: "tuberculosis", medicines: ["Isoniazid", "Rifampin", "Ethambutol"], remedies: ["Proper ventilation", "Wear a mask", "Improve nutrition"], checkups: ["Chest X-ray", "Sputum test", "Pulmonologist"] }
];

const getSuggestions = (extractedText) => {
    extractedText = extractedText.toLowerCase();
    const matchedDiseases = diseaseDatabase.filter(disease => extractedText.includes(disease.name));
    if (matchedDiseases.length === 0) {
        return { text: extractedText, medicines: ["Consult a doctor or dentist"], remedies: ["Maintain good hygiene", "Stay hydrated", "Follow a balanced diet"], checkups: ["General health or dental checkup"] };
    }
    const medicines = [...new Set(matchedDiseases.flatMap(disease => disease.medicines))];
    const remedies = [...new Set(matchedDiseases.flatMap(disease => disease.remedies))];
    const checkups = [...new Set(matchedDiseases.flatMap(disease => disease.checkups))];
    return { text: extractedText, medicines, remedies, checkups };
};

const Ai = () => {
    const [image, setImage] = useState(null);
    const [fileName, setFileName] = useState("");
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
                localStorage.setItem("uploadedImage", reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleExtractText = async () => {
        if (!image) return;
        setLoading(true);
        Tesseract.recognize(image, "eng")
            .then(({ data: { text } }) => {
                setResult(getSuggestions(text));
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error extracting text:", err);
                setLoading(false);
            });
    };

    return (
        <>
            <Banner />
            <div className="ai-container">
                {!image && (
                    <div className="upload-area">
                        <input type="file" id="file-upload" accept="image/*" onChange={handleImageChange} className="file-input" />
                    </div>
                )}

                {image && (
                    <div className="grid-container">
                        <div className="image-section">
                            <p className="file-name">{fileName}</p>
                            <img src={image} alt="Uploaded Preview" className="uploaded-image" />
                            <button onClick={handleExtractText} className="extract-btn">Extract Text</button>
                        </div>
                        <div className="text-section">
                            {loading && <p className="processing-text">Processing...</p>}
                            {result && (
                                <div className="result-box">
                                    <h3>Extracted Text:</h3>
                                    <p>{result.text}</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {result && (
                    <div className="ai-suggestions">
                        <h3>AI Suggestions:</h3>
                        <p><strong>Medicines:</strong> {result.medicines.join(", ")}</p>
                        <p><strong>Remedies:</strong> {result.remedies.join(", ")}</p>
                        <p><strong>Checkups:</strong> {result.checkups.join(", ")}</p>
                    </div>
                )}
            </div>
        </>
    );
    
};
export default Ai;
